import angular from "angular"

import { vsName as reportingServerProviderName, ReportingServerProvider } from './server'
import { vsName as singleReportDownloaderName, directive as singleReportDownloaderDirectiveFactory } from './ui/singleReportDownloader'
import { vsName as reportBatchDownloaderName, reportBatchDownloaderDirectiveFactory } from './ui/reportBatchDownloader'

export const vsName = 'reporting'

const dependencies: string[] = []
const reportingModule = angular.module('reporting', dependencies)

reportingModule
  .directive(singleReportDownloaderName, singleReportDownloaderDirectiveFactory)
  .directive(reportBatchDownloaderName, reportBatchDownloaderDirectiveFactory)
  .provider(reportingServerProviderName, ReportingServerProvider)